<template>
    <!--  <b-link class='nav-link' :to='to'  exact exact-active-class='active-link'>{{ label }}</b-link> -->
    <a
        v-if="external"
        class="nav-link"
        :href="to"
        :target="newTab ? '_blank' : '_self'"
        rel="noopener noreferrer"
        :class="{ disabled: disabled === true }"
    >
        <span style="font-weight: 500">{{ label }}</span>
    </a>
    <router-link
        v-else
        class="nav-link"
        :to="to"
        :exact="exact"
        active-class="activeClass"
        :class="{ disabled: disabled === true }"
    >
        <PulsatingDot v-if="isNew" :title="$t('components.navigation.navigation.newFeature')" />
        <span style="font-weight: 500" :class="isNew && 'leftpadding'">{{ label }}</span>
    </router-link>
</template>

<script>
import PulsatingDot from '../miscellaneous/PulsatingDot';
export default {
    name: 'NavLink',
    components: { PulsatingDot },
    props: {
        label: String,
        to: String,
        activeClass: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        exact: {
            type: Boolean,
            default: false,
        },
        external: {
            type: Boolean,
            default: false,
        },
        newTab: {
            type: Boolean,
            default: true,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.nav-link {
    color: rgba(0, 0, 0, 0.7);
    font-size: 15px;
}
.disabled {
    pointer-events: none;
    cursor: default;
    color: rgba(255, 255, 255, 0.8) !important;
}
.leftpadding {
    padding-left: 20px;
}
</style>
